export default function DSA_Bubble_Sort_Time() {
  return <div>DSA_Bubble_Sort_Time Component</div>;
}
